/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TechList from '../../components/techSupports/TechList';
import { useNavigate } from 'react-router-dom';
import { listPlanTechs } from '../../modules/techModule/techPlans';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import PlanTechSearchContainer from './PlanTechSearchContainer';
import TechReqStatusChip from '../../components/common/datagrid/TechReqStatusChip';

const PlanTechListContainer = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { techs, error, loading } = useSelector(({ techModule, loading }) => ({
    techs: techModule.planTechs.techs,
    error: techModule.planTechs.error,
    loading: loading['tech/LIST_PLAN_TECHS'],
  }));

  useEffect(() => {
    dispatch(listPlanTechs());
  }, []);

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'reqUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'planUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },

      {
        field: 'planNo',
        headerName: '작업예정번호',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'plnTitle',
        headerName: '예정서명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'center',
      },
      {
        field: 'plnTyp',
        headerName: '작업 계획 종류',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'plnStrtDt',
        headerName: '작업요청시작일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'plnEndDt',
        headerName: '작업요청종료일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'plnNm',
        headerName: '작업예정자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    navigate(`/plantechmng/${param.id}`)
  };

  return (
    <>
      <BreadcrumbsContainer title="기술지원/작업지원계획관리/계획 리스트" icon="tech" />
      <PlanTechSearchContainer />
      <TechList
        columns={columns}
        rows={techs}
        loading={loading}
        handleRowClick={handleRowClick}
      />
    </>
  );
};

export default PlanTechListContainer;
